// extracted by mini-css-extract-plugin
export default {"collections":"StoriesExample_collections__D3mEv","slide":"StoriesExample_slide__u0E72"};